// Utils
import Yup from "../../../utils/yup";

export default Yup.object().shape({
  customer_name: Yup.string().required("Required User name"),
  // customer_phone: Yup.string().required("Required"),

  // customer_phone: Yup.string()
  //   .transform((values) => {
  //     if (values?.includes(phoneNumberCountry)) {
  //       return values;
  //     }

  //     // return `${phoneNumberPrefix}${values}`;
  //     return `${numberPrefix}${values}`;

  //   })
  //   // .phone(phoneNumberCountry, false, "Phone number not valid!")
  //   .required()
  //   .test("Check prefix", "Phone number not valid!", function () {
  //     let customer_phone = this.parent["customer_phone"];
  //     if (customer_phone) {
  //       // return customer_phone.startsWith(phoneNumberPrefix) ? true : false;
  //       return customer_phone.startsWith(numberPrefix) ? true : false;

  //     }
  //   }),
  customer_phone: Yup.string()
    .transform((value) => {
      // Clean the phone number for validation
      if (!value) return value;
      
      let cleaned = value.toString().trim();
      
      // Remove prefixes
      if (cleaned.startsWith("+64")) {
        cleaned = cleaned.replace("+64", "");
      } else if (cleaned.startsWith("+61")) {
        cleaned = cleaned.replace("+61", "");
      } else if (cleaned.startsWith("64") && cleaned.length > 9) {
        cleaned = cleaned.replace("64", "");
      } else if (cleaned.startsWith("61") && cleaned.length > 9) {
        cleaned = cleaned.replace("61", "");
      }
      
      // Remove leading zeros and non-numeric characters
      cleaned = cleaned.replace(/^0+/, "").replace(/[^0-9]/g, '');
      
      return cleaned;
    })
    .matches(/^[0-9]+$/, "Phone number must contain only numbers")
    .min(8, "Phone number must be at least 8 characters long")
    .required("Phone number is required"),
  customer_email: Yup.string()
    .email("Invalid Email")
    .required("Required Valid Email address"),
});
